<template>
    <el-dialog class="avatar-dialog" v-model="dialogVisible" fullscreen @click="dialogVisible = false" :show-close="false">
      <el-carousel :interval="0" :arrow="showArrow" height="100vh" ref="carousel" :initial-index="index">
        <el-carousel-item v-for="(photo, index) in fileList" :key="index">
          <img style="width: 100vw; height: 99vh; object-fit: contain;" :src="photo" alt="Avatar"/>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
</template>

<script>
import { Carousel, CarouselItem } from 'element-plus'

export default {
  components: {
    Carousel,
    CarouselItem
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    src: {
      type: String,
      required: false
    },
    srcList: {
      type: Array,
      required: false,
      default: null
    },
    index: {
      type: Number,
      required: false,
      default: 0
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    },
    fileList: {
      get() {
        return this.srcList || [this.src];
      },
    },
    showArrow: {
      get() {
        if (this.fileList.length > 1) {
          // console.log("show arrow")
          return 'always'
        }
        // console.log("hide arrow")
        return 'never'
      }
    }
  },
  watch: {
    index: {
      handler(newVal) {
        // console.log("index in watch: ", newVal)
        if (this.$refs.carousel) {
            this.$refs.carousel.setActiveItem(newVal);
        }
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style>
/* Global styles for the photo dialog */
.el-dialog.avatar-dialog {
  padding: 0;
  margin: 0 !important;
  /* height: 100vh;
  max-width: 100vw; */
}

.el-dialog.avatar-dialog .el-dialog__header,
.el-dialog.avatar-dialog .el-dialog__headerbtn,
.el-dialog.avatar-dialog .el-dialog__headerbtn .el-dialog__close {
  /* display: none !important; */
  padding: 0 !important;
  margin: 0 !important;
}

.el-dialog.avatar-dialog .el-dialog__body {
  padding: 0 !important;
  margin: 0 !important;
  /* height: 100vh; */
}

.el-carousel__button {
  background-color: #ff0000 !important;
}

</style>
